<div id="camera-settings" [class.opened]="opened$ | async" (click)="$event.stopPropagation()">
  <div id="camera-type-notification" [class.opened]="showNotification$ | async">
    {{ showNotification$ | async }}
  </div>

  <h1>{{ 'Camera settings' | translate }}</h1>

  <p>{{ 'Type' | translate }}</p>
  @if (annotationService.isAnnotationMode$ | async) {
  <p>
    {{ 'Switching the camera type is not supported while annotating' | translate }}
  </p>
  } @else {
  <k-button-row>
    <k-button
      (click)="babylon.cameraManager.setCameraType('ArcRotateCamera')"
      [type]="
        (babylon.cameraManager.cameraType$ | async) === 'ArcRotateCamera'
          ? 'solid-primary'
          : 'outlined-primary'
      "
      full-width
      >{{ 'Orbit' | translate }}</k-button
    >
    <k-button
      (click)="babylon.cameraManager.setCameraType('UniversalCamera')"
      [type]="
        (babylon.cameraManager.cameraType$ | async) === 'UniversalCamera'
          ? 'solid-primary'
          : 'outlined-primary'
      "
      full-width
      >{{ 'Free' | translate }}</k-button
    >
  </k-button-row>
  }

  <k-slider
    [label]="('Speed' | translate) + ' (' + cameraSpeed() + 'x)'"
    [min]="25"
    [max]="200"
    [showInfo]="false"
    [showTooltip]="false"
    [startingValue]="cameraSpeed() * 100"
    (valueChanged)="cameraSpeed.set($event / 100)"
  />

  <hr />
  <k-button (click)="resetCamera()" type="outlined-secondary">{{ 'Reset camera' | translate }}</k-button>
</div>
